import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { useSiteConfig } from "../context/SiteConfigContext";
import { useCart } from "../context/CartContext";
import { CategoryContext } from "../context/CategoryContext";
import Auth from "../utils/AuthUtils";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import SearchCanvas from "../pages/canvas/SearchCanvas";

import {
  Search,
  ShoppingBag,
  User,
  Heart,
  Menu,
  X,
} from "lucide-react";

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  const isLoggedIn = Auth.getToken();

  useEffect(() => {
    if (!searchText) {
      setIsSearchOpen(false);
    }
  }, [searchText]);

  if (!config) return null;

  return (
    <>
      <header className="funky-nav-container">

        {/* TOPBAR */}
        <div className="glitch-topbar">
          <div className="marquee-content">
            <span>
              ⚡{" "}
              {config?.topBarText || "FREE SHIPPING ON ALL ORDERS"} ⚡
              SHINE WITH SNACKIYA ⚡ EXCLUSIVE DROP ⚡
            </span>

            <span>
              ⚡{" "}
              {config?.topBarText || "FREE SHIPPING ON ALL ORDERS"} ⚡
              SHINE WITH SNACKIYA ⚡ EXCLUSIVE DROP ⚡
            </span>

            <span>
              ⚡{" "}
              {config?.topBarText || "FREE SHIPPING ON ALL ORDERS"} ⚡
              SHINE WITH SNACKIYA ⚡ EXCLUSIVE DROP ⚡
            </span>

            <span>
              ⚡{" "}
              {config?.topBarText || "FREE SHIPPING ON ALL ORDERS"} ⚡
              SHINE WITH SNACKIYA ⚡ EXCLUSIVE DROP ⚡
            </span>
          </div>
        </div>

        {/* NAVBAR */}
        <nav className="main-navbar">
          <div className="nav-content-wrapper">

            {/* DESKTOP LINKS */}
            <div className="nav-links-desktop">
              <NavLink to="/" className="funky-link">
                HOME
              </NavLink>

              <div className="dropdown-container">
                <NavLink to="/shop" className="funky-link">
                  SHOP
                </NavLink>

                <div className="mega-menu-funky">
                  {categories &&
                    categories.slice(0, 6).map((cat) => (
                      <Link
                        key={cat._id}
                        to={`/categories/${cat.slugPath}`}
                        className="mega-item"
                      >
                        {cat.name}
                      </Link>
                    ))}
                </div>
              </div>

              <NavLink to="/about-us" className="funky-link">
                About Us
              </NavLink>

              <NavLink to="/contact-us" className="funky-link">
                Contact Us
              </NavLink>
            </div>

            {/* LOGO */}
            <Link to="/" className="nav-logo-box">
              <img
                src={config?.logo}
                alt="Logo"
                className="nav-logo-img"
              />
            </Link>

            {/* RIGHT ACTIONS */}
            <div className="nav-actions">

              {/* DESKTOP SEARCH */}
              <div className="search-pill d-none d-md-flex position-relative">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setIsSearchOpen(true);
                  }}
                  onFocus={() =>
                    searchText && setIsSearchOpen(true)
                  }
                />

                <Search size={16} />

                <SearchCanvas
                  isOpen={
                    isSearchOpen && !isMobileMenuOpen
                  }
                  searchText={searchText}
                  setSearchText={setSearchText}
                />
              </div>

              {/* ICONS */}
              <div className="icon-group">

                {/* WISHLIST */}
                <Link
                  to="/wishlist"
                  className="action-btn-circle d-none d-md-flex"
                >
                  <Heart size={18} />
                </Link>

                {/* ACCOUNT */}
                <Link
                  to={
                    isLoggedIn
                      ? "/users/dashboard"
                      : "/users/login"
                  }
                  className="action-btn-circle d-none d-md-flex"
                >
                  <User size={18} />
                </Link>

                {/* CART */}
               <button
  type="button"
  className="action-btn-circle cart-btn-funky d-none d-md-flex"
  data-bs-toggle="offcanvas"
  data-bs-target="#shoppingCartCanvas"
>
  <ShoppingBag size={18} className="text-dark" />

  {cartItems.length > 0 && (
    <span className="cart-count-pop">
      {cartItems.length}
    </span>
  )}
</button>

                {/* MOBILE MENU */}
                <button
                  className="mobile-toggle-btn d-md-none"
                  onClick={() =>
                    setIsMobileMenuOpen(true)
                  }
                >
                  <Menu size={28} />
                </button>
              </div>
            </div>
          </div>
        </nav>

        {/* MOBILE MENU */}
        <div
          className={`funky-mobile-overlay ${
            isMobileMenuOpen ? "open" : ""
          }`}
        >
          {/* HEADER */}
          <div className="overlay-header">
            <div className="nav-logo-box">
              <img
                src={config?.logo}
                alt="Logo"
                className="nav-logo-img"
              />
            </div>

            <button
              className="close-overlay text-dark"
              onClick={() =>
                setIsMobileMenuOpen(false)
              }
            >
              <X size={32} />
            </button>
          </div>

          {/* CONTENT */}
          <div className="overlay-content">

            {/* MOBILE TOP ACTIONS */}
            <div className="mobile-top-actions">

              {/* SEARCH */}
              <div className="mobile-search-box position-relative">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setIsSearchOpen(true);
                  }}
                  onFocus={() =>
                    searchText && setIsSearchOpen(true)
                  }
                />

                <SearchCanvas
                  isOpen={
                    isSearchOpen &&
                    isMobileMenuOpen
                  }
                  searchText={searchText}
                  setSearchText={setSearchText}
                />
              </div>

              {/* WISHLIST */}
              <Link
                to="/wishlist"
                className="mobile-mini-action"
                onClick={() =>
                  setIsMobileMenuOpen(false)
                }
              >
                <Heart size={18} />
              </Link>

              {/* CART */}
             <button
  type="button"
  className="mobile-mini-action position-relative"
  data-bs-toggle="offcanvas"
  data-bs-target="#shoppingCartCanvas"
  onClick={() => setIsMobileMenuOpen(false)}
>
  <ShoppingBag
    size={18}
    className="text-dark"
    strokeWidth={2.2}
  />

  {cartItems.length > 0 && (
    <span className="cart-count-pop">
      {cartItems.length}
    </span>
  )}
</button>
            </div>

            {/* NAVIGATION */}
            <NavLink
              to="/"
              onClick={() =>
                setIsMobileMenuOpen(false)
              }
            >
              HOME
            </NavLink>

            <NavLink
              to="/shop"
              onClick={() =>
                setIsMobileMenuOpen(false)
              }
            >
              SHOP ALL
            </NavLink>

            {/* MOBILE CATEGORIES */}
            <div className="mobile-cat-list mt-1 mb-2">
              {categories &&
                categories
                  .slice(0, 5)
                  .map((cat) => (
                    <Link
                      key={cat._id}
                      to={`/categories/${cat.slugPath}`}
                      onClick={() =>
                        setIsMobileMenuOpen(false)
                      }
                    >
                      {cat.name}
                    </Link>
                  ))}
            </div>

            <NavLink
              to="/about-us"
              onClick={() =>
                setIsMobileMenuOpen(false)
              }
            >
              OUR STORY
            </NavLink>

            <NavLink
              to="/contact-us"
              onClick={() =>
                setIsMobileMenuOpen(false)
              }
            >
              CONTACT US
            </NavLink>

            <NavLink
              to={
                isLoggedIn
                  ? "/users/dashboard"
                  : "/users/login"
              }
              onClick={() =>
                setIsMobileMenuOpen(false)
              }
            >
              {isLoggedIn ? "ACCOUNT" : "LOGIN"}
            </NavLink>
          </div>
        </div>
      </header>

      {/* SEARCH BACKDROP */}
      {isSearchOpen && !isMobileMenuOpen && (
        <div
          className="search-click-overlay-closer"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 990,
          }}
          onClick={() =>
            setIsSearchOpen(false)
          }
        />
      )}

      {/* OFFCANVAS */}
      <div
        className="offcanvas offcanvas-end funky-offcanvas"
        id="shoppingCartCanvas"
      >
        <CartCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end funky-offcanvas"
        id="loginOffCanvas"
      >
        <LoginCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end funky-offcanvas"
        id="registerOffCanvas"
      >
        <RegisterCanvas />
      </div>
    </>
  );
}

export default Header;